export default __webpack_public_path__ + "static/media/ONE_NINE_TWO.ef5ada66.png";